<template>
	<div class="wrapper">
		<headerTag />
			<p class="userIn1" style="margin-top: 6.15rem;">
				<input type="password" placeholder="旧登录密码" autocomplete="off" maxlength="20" ref="oldPwd"/>
				<img src="../../assets/images/user/password1.png" alt="" class="passwordImg" />
			</p>
			<p class="userIn1">
				<input type="password" placeholder="新密码" autocomplete="off" maxlength="20" ref="newPwd"/>
				<img src="../../assets/images/user/password1.png" alt="" class="passwordImg" />
			</p>
			<p class="userIn1" style="margin-bottom: 0;">
				<input type="password" placeholder="确认新密码" autocomplete="off" maxlength="20" ref="confirmPwd"/>
				<img src="../../assets/images/user/password1.png" alt="" class="passwordImg" />
			</p>
			<button class="userBtn1" @click="updatePwd" :disabled="isDisable">完成</button>
		<footerTag />
	</div>

</template>

<script>
   
    import "../../assets/css/user.scss"
    import headerTag from '@/components/headerTag/headerTag.vue'
    import footerTag from '@/components/footerTag/footerTag.vue'
	import {VidateUtil} from '../../assets/js/validate.js' 
	import { Dialog } from 'vant'

	export default {
		name: 'passwordChange',
		props: {
        
		},
		data:function(){
			return {
				isDisable:false,
			}
		},
		methods:{
			getUserInfo(){
				this.axios({
					method: 'POST',
					url:'/user/getUserName',
				}).then((res)=>{
					if(res.data.obj == null || res.data.obj == ''){
						// 用户未登录
				  		let currPath=window.location.href;
				  		window.location.href='/login?targetUrl='+currPath;
					}else{
						
					}
				}).catch((err)=>{
					
				})
			},
			updatePwd(){
				let oldPwd=this.$refs.oldPwd.value;
				let newPwd=this.$refs.newPwd.value;
				let confirmPwd=this.$refs.confirmPwd.value;
				//旧密码
				if (oldPwd == "" || oldPwd == null) {
					this.$message.error({message: '旧密码不能为空'});
					return;
				}
				if (oldPwd.length > 20 || oldPwd.length < 8) {
					this.$message.error({message: '旧密码格式不正确'});
					return;
				}
				if(!VidateUtil.checkPassword(oldPwd)){
					this.$message.error({message: '旧密码格式不正确'});
					return;
				}
				//新密码
				if (newPwd == "" || newPwd == null) {
					this.$message.error({message: '新密码不能为空'});
					return;
				}
				if (newPwd.length > 20 || newPwd.length < 8) {
					this.$message.error({message: '密码长度限8~20个字数且不支持空格'});
					return;
				}
				if(!VidateUtil.checkPassword(newPwd)){
					this.$message.error({message: '密码长度限8~20个字数且不支持空格'});
					return;
				}
				//确认密码
				if (confirmPwd == "" || confirmPwd == null) {
					this.$message.error({message: '确认密码不能为空'});
					return;
				}
				if (confirmPwd.length > 20 || confirmPwd.length < 8) {
					this.$message.error({message: '密码长度限8~20个字数且不支持空格'});
					return;
				}
				if(!VidateUtil.checkPassword(confirmPwd)){
					this.$message.error({message: '密码长度限8~20个字数且不支持空格'});
					return;
				}
				if(confirmPwd != newPwd){
					this.$message.error({message: '确认密码与新密码不一致'});
					return;
				}
				//按钮不可点击
				this.isDisable=true; 
				this.axios({
					method: 'POST',
					url:'/user/updatePwd',
					params:{
						oldPwd:oldPwd,
						newPwd:newPwd,
						confirmPwd:confirmPwd
					},
				}).then((res)=>{
						this.isDisable=false; //按钮可点击
						if(res.data.code==1000){
							//成功
							Dialog.alert({
							  message: '修改成功'
							}).then(() => {
							  this.$router.push({ name:'baseMessage' });
							});
						}else if(res.data.code == 1110){
				  			//未登录
				  			let currPath=window.location.href;
				  			window.location.href='/login?targetUrl='+currPath;
				  		}else if(res.data.code==1002){
							this.$message.error({message: res.data.message});
						}else{
							this.$message.error({message: '网络异常，请稍后重试'});
						}
				}).catch((err)=>{
					this.isDisable=false; //按钮可点击
					this.$message.error({message: '网络异常，请稍后重试'});
				})
			}
		},
		components: {
			headerTag,
			footerTag,
			VidateUtil,
			Dialog
		},
		created() {
			this.getUserInfo();
		}
	}

</script>